var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessEligibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6083_14998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 39.5,
    r: 34.4125,
    stroke: "#314064",
    strokeWidth: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 68C55.2401 68 68 55.2401 68 39.5C68 23.7599 55.2401 11 39.5 11C23.7599 11 11 23.7599 11 39.5",
    stroke: "#799DD2",
    strokeWidth: 2.175,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6083_14998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7492 48.6626C35.0679 48.6629 34.4146 48.3921 33.9332 47.9099L28.4431 42.4218C27.8523 41.8309 27.8523 40.8729 28.4431 40.282C29.034 39.6913 29.9919 39.6913 30.5828 40.282L35.7492 45.4484L49.4172 31.7804C50.0081 31.1896 50.966 31.1896 51.5569 31.7804C52.1477 32.3713 52.1477 33.3292 51.5569 33.9202L37.5651 47.9099C37.0838 48.3921 36.4305 48.6629 35.7492 48.6626Z",
    fill: "#374957"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6083_14998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6083_14998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEligibility);
export default __webpack_public_path__ + "static/media/success-eligibility.55f36b714aaf88f870f66c3e19d0e2cc.svg";
export { ForwardRef as ReactComponent };